export default __webpack_public_path__ + "static/media/instagramhumano.d1a0456a.svg";